var React = require('react');

function PlayerVideo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M53 106C82.2711 106 106 82.2711 106 53C106 23.7289 82.2711 0 53 0C23.7289 0 0 23.7289 0 53C0 82.2711 23.7289 106 53 106Z","fill":"black","key":0}),React.createElement("path",{"d":"M78.7478 53.3711L40 75.7423L40 31L78.7478 53.3711Z","fill":"white","key":1})]);
}

PlayerVideo.defaultProps = {"width":"76","height":"76","viewBox":"0 0 106 106","fill":"none"};

module.exports = PlayerVideo;

PlayerVideo.default = PlayerVideo;
